import gsap from "gsap";
import { type LenisRef, ReactLenis } from "lenis/react";
import { useEffect, useRef } from "react";

function InjectLenis() {
  const lenisRef = useRef<null | LenisRef>(null);
  useEffect(() => {
    function update(time: number) {
      lenisRef.current?.lenis?.raf(time * 1000);
    }
    gsap.ticker.add(update);
    return () => {
      gsap.ticker.remove(update);
    };
  }, []);
  useEffect(() => {
    if (!lenisRef.current?.lenis) return;
    const lenis = lenisRef.current.lenis;
    const handleWheel = (e: WheelEvent) => {
      const target = e.target as HTMLElement;
      let element: HTMLElement | null = target;
      while (element && element !== document.body) {
        const hasScroll = element.scrollHeight > element.clientHeight;
        const isScrollable =
          hasScroll && element.hasAttribute("data-lenis-prevent");
        if (isScrollable) {
          const isAtTop = element.scrollTop === 0;
          const isAtBottom =
            Math.abs(
              element.scrollHeight - element.clientHeight - element.scrollTop,
            ) < 1;
          if ((e.deltaY < 0 && !isAtTop) || (e.deltaY > 0 && !isAtBottom)) {
            lenis.stop();
            return;
          }
        }
        element = element.parentElement;
      }
      lenis.start();
    };
    window.addEventListener("wheel", handleWheel, { passive: true });
    return () => {
      window.removeEventListener("wheel", handleWheel);
    };
  }, []);

  return (
    <ReactLenis
      root
      options={{
        autoRaf: false,
        lerp: 0.03,
        duration: 2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        orientation: "vertical",
        gestureOrientation: "vertical",
        smoothWheel: true,
        syncTouch: false,
        syncTouchLerp: 0.075,
        wheelMultiplier: 1,
        touchMultiplier: 2,
        infinite: false,
      }}
      ref={lenisRef}
    />
  );
}

export default InjectLenis;
